import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import classNames from "classnames";
import isNumber from "lodash/isNumber";
import isUndefined from "lodash/isUndefined";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { NEW_WORKSPACE } from "./constants";
import WorkSpaceEditor from "./workSpaceEditor";
import locale from "./workSpaceEditorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 400,
    MODAL_HEIGHT: 311
};
function WorkSpaceEditorPanel(props) {
    const [show, setShow] = useState(false);
    const workSpaceIdRef = useRef(props.workSpaceId);
    const [inEditingProgress, setInEditingProgress] = useState(new Set());
    const title = useMemo(() => isUndefined(props.workSpaceId)
        ? ""
        : props.workSpaceId === NEW_WORKSPACE.Id
            ? locale.CREATE_WORK_SPACE
            : locale.EDIT_WORK_SPACE, [props.workSpaceId]);
    useEffect(() => {
        workSpaceIdRef.current = props.workSpaceId;
        props.workSpaceId && props.onInitialized && props.onInitialized(props.workSpaceId);
        setShow(!isUndefined(props.workSpaceId));
    }, [props.workSpaceId]);
    const handleHideModal = useCallback((e) => {
        if (e)
            props.onClose && props.onClose();
        else
            setShow(false);
    }, [props.onClose]);
    const handleClose = useCallback((workSpaceId) => {
        if (workSpaceId === workSpaceIdRef.current)
            setShow(false);
    }, []);
    const handleEditingInProgress = useCallback((inProgress, workSpaceId) => {
        setInEditingProgress(prev => {
            if (inProgress && prev.has(workSpaceId))
                return prev;
            const result = new Set(prev);
            if (inProgress)
                result.add(workSpaceId);
            else
                result.delete(workSpaceId);
            return result;
        });
    }, []);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: classNames("modal-padding", isNumber(props.workSpaceId) &&
            inEditingProgress.has(props.workSpaceId) &&
            "no-pointer-events"), shadingColor: shadingLightestColor, className: "bg-blur", title: title, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement(WorkSpaceEditor, { onHide: handleClose, onEditingInProgress: handleEditingInProgress })));
}
export default memo(WorkSpaceEditorPanel);
